import React from 'react'
import styled from 'styled-components'
import { TextBox } from '../atoms/Textbox'
import { ValidationErrorMessage } from '../atoms/ValidationErrorMessage'

type Props = {
  type: 'text' | 'tel' | 'email'
  value: string
  onChange: React.ChangeEventHandler<HTMLInputElement>
  placeholder: string
  $errors?: string[]
}

export const TextBoxWithValidation: React.FC<Props> = props => {
  return (
    <Wrapper>
      <TextBox {...props} />
      {props.$errors && props.$errors.length > 0 && (
        <ValidationErrorMessage
          message={props.$errors ? props.$errors.join('') : ''}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  margin-top: 4px;
`
